/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimal,
  AmountDecimal$inboundSchema,
  AmountDecimal$Outbound,
  AmountDecimal$outboundSchema,
} from "./amountdecimal.js";
import {
  CreatePaymentLinkLineItemOption,
  CreatePaymentLinkLineItemOption$inboundSchema,
  CreatePaymentLinkLineItemOption$Outbound,
  CreatePaymentLinkLineItemOption$outboundSchema,
} from "./createpaymentlinklineitemoption.js";

/**
 * Represents a single line item in a payment link, including optional modifiers and quantity.
 */
export type CreatePaymentLinkLineItem = {
  /**
   * The name of the item.
   */
  name: string;
  /**
   * The base price of the item before applying option modifiers.
   */
  basePrice: AmountDecimal;
  /**
   * The quantity of this item.
   */
  quantity: number;
  /**
   * Optional list of modifiers applied to this item (e.g., toppings, upgrades, customizations).
   */
  options?: Array<CreatePaymentLinkLineItemOption> | undefined;
  /**
   * Optional list of images associated with this line item.
   */
  imageIDs?: Array<string> | undefined;
  /**
   * Optional unique identifier associating the line item with a product.
   */
  productID?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItem$inboundSchema: z.ZodType<
  CreatePaymentLinkLineItem,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  basePrice: AmountDecimal$inboundSchema,
  quantity: z.number().int(),
  options: z.array(CreatePaymentLinkLineItemOption$inboundSchema).optional(),
  imageIDs: z.array(z.string()).optional(),
  productID: z.string().optional(),
});
/** @internal */
export type CreatePaymentLinkLineItem$Outbound = {
  name: string;
  basePrice: AmountDecimal$Outbound;
  quantity: number;
  options?: Array<CreatePaymentLinkLineItemOption$Outbound> | undefined;
  imageIDs?: Array<string> | undefined;
  productID?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItem$outboundSchema: z.ZodType<
  CreatePaymentLinkLineItem$Outbound,
  z.ZodTypeDef,
  CreatePaymentLinkLineItem
> = z.object({
  name: z.string(),
  basePrice: AmountDecimal$outboundSchema,
  quantity: z.number().int(),
  options: z.array(CreatePaymentLinkLineItemOption$outboundSchema).optional(),
  imageIDs: z.array(z.string()).optional(),
  productID: z.string().optional(),
});

export function createPaymentLinkLineItemToJSON(
  createPaymentLinkLineItem: CreatePaymentLinkLineItem,
): string {
  return JSON.stringify(
    CreatePaymentLinkLineItem$outboundSchema.parse(createPaymentLinkLineItem),
  );
}
export function createPaymentLinkLineItemFromJSON(
  jsonString: string,
): SafeParseResult<CreatePaymentLinkLineItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreatePaymentLinkLineItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreatePaymentLinkLineItem' from JSON`,
  );
}
